import { FC } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Nullable } from 'common-types';
import { Recipient } from '../types/notification-settings-types';

const RecipientsAutocomplete: FC<
  React.PropsWithChildren<RecipientsAutocompleteProps>
> = props => {
  const {
    isDisabled,
    recipients,
    potentialRecipients,
    handleChangeRecipients,
  } = props;

  return (
    <Autocomplete
      multiple
      id='tags-outlined'
      value={recipients || []}
      options={potentialRecipients || []}
      getOptionLabel={option => option.name}
      disabled={isDisabled}
      filterSelectedOptions
      renderInput={params => (
        <TextField {...params} label='Notify members' placeholder='Members' />
      )}
      onChange={(_, newRecipients) => handleChangeRecipients(newRecipients)}
      isOptionEqualToValue={(option, value) => option.name === value.name}
    />
  );
};

interface RecipientsAutocompleteProps {
  isDisabled: boolean;
  recipients: Nullable<Recipient[]>;
  potentialRecipients: Nullable<Recipient[]>;
  handleChangeRecipients: (newRecipients: Recipient[]) => void;
}

export default RecipientsAutocomplete;
